<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      :before-close="beforeClose"
      v-if="crudFlag"
    >
      <template slot="upkeepTimeForm" slot-scope="">
        <el-time-picker
          is-range
          v-model="form.upkeepTime"
          range-separator="至"
          format="HH:mm"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        >
        </el-time-picker>
      </template>

      <template slot-scope="" slot="planProjectForm">
        <avue-crud
          v-model="form2"
          :data="projectData"
          :option="projectOption"
          :before-open="rowAddDialog"
          v-if="showAddCrud"
          @row-save="projectRowSave"
          @row-del="projectRowDel"
        >
          <template slot="objectTypeForm"> </template>
          <template slot="deviceIdForm">
            <el-select
              v-model="form2.deviceId"
              placeholder="请输入设备名或编号筛选"
              @change="(value, label) => changeDevice(value, label)"
              filterable
            >
              <el-option
                v-for="item in deviceIdList"
                :key="item.id"
                :label="item.name + '-' + item.code"
                :value="item.id"
              >
                <span style="float: left">{{
                  item.name + "-" + item.code
                }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.areaName
                }}</span>
              </el-option>
            </el-select>
          </template>
          <template slot="devicePartIdForm">
            <el-select v-model="form2.devicePartId" placeholder="请选择">
              <el-option
                v-for="item in devicePartIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </avue-crud>
      </template>
      <template slot-scope="" slot="planProjectLabel">
        <span style="color: #f56c6c">* </span><span>维保标准</span>
      </template>
      <template slot-scope="{ error }" slot="planProjectError">
        <p style="color: #f56c6c">{{ error }}</p>
      </template>

      <template slot="projectSearch" slot-scope="">
        <el-select
          v-if="projectFlag"
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value) => projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="contractIdSearch" slot-scope="">
        <!-- <el-select
          v-model="query.contractId"
          placeholder="请选择合同"
          style="width: 100%"
          filterable
          clearable
        >
          <el-option
            v-for="item in contractList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
        <avue-input-tree
          v-model="query.contractId"
          placeholder="请选择合同"
          type="tree"
          :dic="contractList"
          :props="{ label: 'name', value: 'id' }"
        ></avue-input-tree>
      </template>
      <template slot="contractIdForm" slot-scope="">
        <avue-input-tree
          v-model="form.contractId"
          placeholder="请选择合同"
          type="tree"
          :dic="contractList"
          :props="{ label: 'name', value: 'id' }"
        ></avue-input-tree>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getDictionary,
  getContractList,
  getContractId,
  getDevicePartId,
  getContractDetail,
} from "@/api/crmedical/upkeep/upkeepplan";
import { mapGetters } from "vuex";
import { getProjectList } from "@/api/crmedical/project/project";

var V = (rule, value, callback) => {
  if (value.length === 0) {
    callback(new Error("请至少添加一项维保内容"));
  }
};
var interval = (rule, value, callback) => {
  if (value > 0 && value < 1000) {
    callback();
  } else {
    callback(new Error("请输入1~999的整数！"));
  }
};
var inputNumber = (rule, value, callback) => {
  if ((typeof value !== "number" && isNaN(value)) || value <= 0) {
    callback(new Error("请输入大于 0 的数字！"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      contractList: [],
      crudFlag: true,
      viewFlag: false,
      devicePartIdList: [],
      projectFlag: true,
      showAddCrud: true,
      upkeepTypeList: [], //维保类型
      projectList: [],
      form: {},
      form2: {
        upkeepType: "",
        devicePartId: "",
      },
      query: {
        contractId: "",
        name: "",
        project: "",
        projectId: "",
        signDept: "",
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: "auto",
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        indexLabel: "序号",
        labelWidth: 120,
        dialogWidth: "70%",
        columnBtn: false,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            rules: [
              {
                required: true,
                message: "请选择项目名称",
                trigger: "change",
              },
            ],
            type: "select",
            dicUrl: "api/v4ward/project/getProjectList",
            props: {
              label: "name",
              value: "id",
            },
            clearable: false,
            span: 6,
          },
          {
            label: "项目名称",
            prop: "project",
            rules: [
              {
                required: true,
                message: "请选择项目名称",
                trigger: "blur",
              },
            ],
            search: true,
            searchslot: true,
            hide: true,
            display: false,
            span: 12,
          },
          {
            label: "计划名称",
            prop: "name",
            rules: [
              {
                required: true,
                message: "请输入计划名称",
                trigger: "change",
              },
            ],
            span: 6,
            search: true,
            maxlength: 20,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "合同",
            prop: "contractId",
            formslot: true,
            searchslot: true,
            hide: true,
            span: 6,
            search: true,
          },
          {
            label: "维保单位",
            prop: "signDept",
            disabled: true,
            hide: true,
            span: 6,
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: "合同",
            prop: "contractName",
            display: false,
            overHidden: true,
          },
          {
            label: "维保时间",
            prop: "upkeepTime",
            type: "timerange",
            span: 10,
            hide: true,
            format: "HH:mm",
            // formslot:true,
            valueFormat: "HH:mm",
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: "请输入维保时间",
                trigger: "bulr",
              },
            ],
          },
          {
            label: "维保时间",
            prop: "upkeepTime2",
            display: false,
          },
          {
            label: "最后一次维保时间",
            prop: "lastUpkeepTime",
            display: false,
            hide: true,
          },
          {
            label: "周期类型",
            prop: "cycleType",
            span: 6,
            rules: [
              {
                required: true,
                message: "请选择周期类型",
                trigger: "change",
              },
            ],
            dataType: "number",
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicUrl: "/api/blade-system/dict/dictionary?code=plan_cycle_type",
          },
          {
            label: "维保周期",
            prop: "cycle",
            type: "number",
            rules: [
              {
                validator: interval,

                trigger: "blur",
              },
              {
                required: true,
                validator: inputNumber,
                trigger: "blur",
              },
            ],
            span: 8,
            maxlength: 3,
            showWordLimit: true,
          },
          {
            label: "计划开始时间",
            prop: "planStartTime",
            display: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          {
            label: "计划结束时间",
            prop: "planEndTime",
            display: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          {
            label: "计划时间",
            prop: "range",
            type: "daterange",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            span: 12,
            rules: [
              {
                required: true,
                message: "请输入计划时间",
                trigger: "change",
              },
            ],
            editDisabled: true,
            tip: "计划时间不允许修改",
            hide: true,
          },
          {
            label: "维保类型",
            prop: "planProject",
            formslot: true,
            labelslot: true,
            errorslot: true,
            hide: true,
            span: 24,
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
      data: [],
      projectData: [],
      projectOption: {
        height: "auto",
        calcHeight: "auto",
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        editBtn: false,
        addBtn: true,
        delBtn: true,
        indexLabel: "序号",
        columnBtn: false,
        refreshBtn: false,
        menuWidth: 100,
        labelWidth: 120,
        dialogWidth: "50%",
        addBtnText: "添 加",
        addTitle: "添 加",
        column: [
          {
            label: "设备设施类型",
            prop: "objectType",
            type: "radio",
            value: "1",
            dataType: "string",
            dicUrl: `/api/blade-system/dict/dictionary?code=device_object_type`,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: [],
            span: 12,
          },
          {
            label: "维保类型",
            prop: "projectType",
            type: "radio",
            value: "1",
            dataType: "string",
            dicUrl: `/api/blade-system/dict/dictionary?code=upkeep_type`,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicData: [],
            span: 12,
          },
          {
            label: "维保设备",
            prop: "deviceName",
            display: false,
            span: 12,
          },
          {
            label: "维保设备",
            prop: "deviceId",
            type: "select",
            props: {
              label: "name",
              value: "id",
            },
            formslot: true,
            addDisplay: true,
            hide: true,
            editDisplay: true,
            rules: [
              {
                required: true,
                message: "请选择维保设备",
                trigger: "change",
              },
            ],
            span: 12,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "维保配件",
            prop: "devicePartId",
            type: "select",
            props: {
              label: "name",
              value: "id",
            },
            formslot: true,
            display: false,
            addDisplay: true,
            hide: true,
            editDisplay: true,
            rules: [
              {
                required: true,
                message: "请选择维保配件",
                trigger: "change",
              },
            ],
            span: 12,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "维保配件",
            prop: "partName",
            display: false,
            span: 12,
          },
          {
            label: "维保内容",
            prop: "content",
            rules: [
              {
                required: true,
                message: "请输入维保内容",
                trigger: "change",
              },
            ],
            type: "textarea",
            maxlength: 500,
            showWordLimit: true,
            overHidden: true,
            span: 24,
          },
        ],
      },
      deviceIdList: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.upkeepplan_add, false),
        viewBtn: this.vaildData(this.permission.upkeepplan_view, false),
        delBtn: this.vaildData(this.permission.upkeepplan_delete, false),
        editBtn: this.vaildData(this.permission.upkeepplan_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  watch: {
    // 新增维保标准中配件的显隐
    "form2.objectType"() {
      // this.form2.deviceId = '';
      // let column = this.findObject(this.projectOption.column, 'devicePartId')
      // let column2 = this.findObject(this.projectOption.column, 'deviceId')

      // if (this.form2.projectType == 1) {
      //   column.display = false;
      // } else if (this.form2.projectType == 2) {
      //   column.display = true;
      //   this.form2.devicePartId = '';
      // }
      console.log("this.form2.objectType======>", this.form2.objectType);
      console.log("this.form2======>", this.form2);
      // this.form2.objectType = '';
      getContractId({
        projectId: this.form.projectId,
        objectType: this.form2.objectType,
      }).then((res) => {
        this.deviceIdList = res.data;
        // this.form2.deviceId = '';
        setTimeout(() => {
          // this.form2.deviceName = '';
          this.form2 = Object.assign({}, this.form2, {
            deviceId: "",
            deviceName: "",
          });
          console.log("this.form2======>", this.form2);
        });
      });
    },
    // 新增维保标准中配件的显隐
    "form2.projectType"() {
      this.form2.deviceId = "";
      let column = this.findObject(this.projectOption.column, "devicePartId");
      let column2 = this.findObject(this.projectOption.column, "deviceId");

      if (this.form2.projectType == 1) {
        column.display = false;
      } else if (this.form2.projectType == 2) {
        column.display = true;
        this.form2.devicePartId = "";
      }
    },
    // 获取配件
    "form2.deviceId"() {
      this.form2.devicePartId = "";
      if (this.form2.projectType == 2) {
        let column = this.findObject(this.projectOption.column, "devicePartId");
        getDevicePartId({
          deviceId: this.form2.deviceId,
        }).then((res) => {
          column.dicData = res.data;
          this.devicePartIdList = res.data;
        });
      }
    },
    // 获取合同列表
    "form.projectId"() {
      this.form.contractId = "";
      this.form2.deviceId = "";
      this.projectData = [];
      getContractList({ projectId: this.form.projectId }).then(({ data }) => {
        this.contractList = data;
        this.form.signDept = "";
      });
    },
    // 获取合同详情
    "form.contractId"() {
      this.form.chargeManId = "";
      this.form.signDept = "";
      if (this.form.contractId) {
        getContractDetail({
          id: this.form.contractId,
        }).then((res) => {
          this.form.signDept = res.data.partnerName;
          this.form.chargeManId = res.data.chargeManId;
        });
      }
    },
  },
  created() {
    this.getDictionary();
  },
  methods: {
    changeDevice(value) {
      this.form2.deviceId = value;
      this.deviceIdList.forEach((value1) => {
        if (value1.id == value) {
          this.form2.deviceName = value1.name;
        }
      });
    },
    projectChange(value) {
      this.projectFlag = false;
      this.query.projectId = value;
      this.query.project = value;
      setTimeout(() => {
        this.projectFlag = true;
      }, 10);
      getContractList({ projectId: value }).then(({ data }) => {
        this.contractList = data;
      });
    },
    // 打开维保标准新增弹窗
    rowAddDialog(done, type, ...a) {
      getDictionary("device_object_type").then((resp) => {
        // resp.data
        getContractId({
          projectId: this.form.projectId,
          objectType: resp.data[0].dictKey,
        }).then((res) => {
          this.deviceIdList = res.data;
        });
      });
      if (type === "add") {
        setTimeout(() => {
          this.form2.content = "";
        }, 10);
      }
      done();
    },
    // 获取字典值
    getDictionary() {
      // 维保类型
      getDictionary("upkeep_type").then((res) => {
        let column = this.findObject(this.projectOption.column, "projectType");
        res.data.forEach((item) => {
          item.label = item.dictValue;
          item.value = item.dictKey;
        });
        column.dicData = res.data;
        this.upkeepTypeList = res.data;
      });
    },
    projectRowSave(row, loading, done) {
      this.showAddCrud = false;

      this.projectData.push(row);
      this.projectData.forEach((item) => {
        item.partName = this.tool.getDictionaryValue(
          this.devicePartIdList,
          "name",
          "id",
          item.devicePartId
        );
      });
      this.form.planProject = this.projectData;

      loading();
      this.showAddCrud = true;
    },
    projectRowDel(row, index) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.projectData.splice(index, 1);
        this.form.planProject = this.projectData;
      });
    },
    rowSave(row, loading, done) {
      console.log("row==>", row);
      if (!row.planProject) {
        this.$message.error("请至少添加一项维保内容!");
        done();
        return;
      }
      this.crudFlag = false;
      row.planStartTime = row.range[0] + " 00:00:00";
      row.planEndTime = row.range[1] + " 23:59:59";
      row.upkeepTime = row.upkeepTime[0] + "~" + row.upkeepTime[1];
      add(row).then(
        () => {
          this.crudFlag = true;
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.resetForm();
        },
        (error) => {
          this.crudFlag = true;
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      if (!row.planProject) {
        this.$message.error("请至少添加一项维保内容!");
        done();
        return;
      }
      this.crudFlag = false;
      row.upkeepTime = row.upkeepTime[0] + "~" + row.upkeepTime[1];
      update(row).then(
        () => {
          this.crudFlag = true;
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.resetForm();
        },
        (error) => {
          this.crudFlag = true;
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.viewFlag = false;
      if (type === "add") {
        setTimeout(() => {
          this.form.projectId = this.projectList[0].id;
        }, 10);
      }
      if (type === "view") {
        this.viewFlag = true;
        this.projectOption.addBtn = false;
        this.projectOption.delBtn = false;
        setTimeout(() => {
          document
            .querySelectorAll(
              ".avue-crud .el-range-editor--small, .avue-form .el-range-editor--small"
            )
            .forEach((el) => {
              el.style.background = "#eee";
            });
        });
      }
      if (type === "edit") {
        setTimeout(() => {
          document
            .querySelectorAll(".el-range-editor.is-disabled")
            .forEach((el) => {
              el.style.background = "#eee";
            });
        });
      }
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.form.range = [data.planStartTime, data.planEndTime];
          this.projectData = data.planProject;
          this.form2 = this.projectData;
          this.form.upkeepTime = this.form.upkeepTime.split("~");
          this.projectData.forEach((item) => {
            if (!item.upkeepType === 2) {
              let column = this.findObject(
                this.projectOption.column,
                "devicePartId"
              );
              getDevicePartId({
                deviceId: item.deviceId,
              }).then((res) => {
                column.dicData = res.data;
              });
            }
          });
        });
      }
      done();
    },
    beforeClose(done, type) {
      this.projectOption.addBtn = true;
      this.projectOption.delBtn = true;
      this.projectData = [];
      this.deviceIdList = [];
      done();
    },
    searchReset() {
      this.query.name = "";
      this.query.contractId = "";
      this.query.signDept = "";
      this.onLoad();
    },
    searchChange(params, done) {
      console.log(params);
      // this.query = params;
      this.query.name = params.name;
      this.query.signDept = params.signDept;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.projectId) {
        console.log(this.query);
        getList(
          Object.assign(
            { current: page.currentPage, size: page.pageSize },
            this.query
          )
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          if (this.data) {
            this.data.forEach((value) => {
              value.upkeepTime2 = value.upkeepTime;
            });
          }
          this.loading = false;
          this.selectionClear();
        });
      } else {
        getProjectList().then((data) => {
          this.projectList = data.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.query.project = this.projectList[0].name;
            getContractList({ projectId: this.projectList[0].id }).then(
              ({ data }) => {
                this.contractList = data;
              }
            );
            getList(
              Object.assign(
                { current: page.currentPage, size: page.pageSize },
                this.query
              )
            ).then(({ data }) => {
              this.page.total = data.total;
              this.data = data.records;
              if (this.data) {
                this.data.forEach((value) => {
                  value.upkeepTime2 = value.upkeepTime;
                });
              }
              this.loading = false;
              this.selectionClear();
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.el-range-editor.is-disabled input[disabled="disabled"] {
  background-color: #eee !important;
}
</style>
